import * as React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { Checkbox, Input } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import { Loader } from "@progress/kendo-react-indicators";
import { Label } from "@progress/kendo-react-labels";
import SubmitButton from "components/common/SubmitButton";

export const SaveJournalTemplateDialog = ({
  show,
  templateName,
  setTemplateName,
  savingTemplate,
  onCancel,
  onSave,
}) => {
  if (!show) return null;

  const isSaveDisabled = savingTemplate || !templateName?.trim();

  return (
    <Dialog title="Add Journal Template" onClose={onCancel} className="dialog-xs">
      <div className="p-4">
        <Label className="mb-1 d-block">Name</Label>
        <Input
          value={templateName}
          onChange={(e) => setTemplateName(e.target.value)}
          placeholder="Enter template name"
          maxLength={80}
        />
      </div>

      <DialogActionsBar>
        <div className="dialog-footer">
          <Button
            className="common-btn bgBtnSecondary me-2"
            type="button"
            onClick={onCancel}
            disabled={savingTemplate}>
            Cancel
          </Button>
          <SubmitButton
            className="common-btn me-4"
            form="journalTemplateSaveForm"
            type="button"
            isLoading={savingTemplate}
            onClick={onSave}
            disabled={isSaveDisabled}>
            Save
          </SubmitButton>
        </div>
      </DialogActionsBar>
    </Dialog>
  );
};

export const LoadJournalTemplatesDialog = ({
  show,
  templates,
  templatesLoading,
  selectedTemplateId,
  setSelectedTemplateId,
  updatingTemplate,
  onClose,
  onLoad,
  onEdit,
  onDelete,
}) => {
  if (!show) return null;

  return (
    <Dialog title="Load Journal Template" onClose={onClose} className="dialog-sm">
      <div className="px-2 position-relative" style={{ minHeight: "260px" }}>
        <Grid
          data={templates}
          dataItemKey={"journalTemplateId"}
          selectable={true}
          onRowClick={(e) => setSelectedTemplateId(e.dataItem.journalTemplateId)}
          style={{ maxHeight: "300px" }}>
          <Column
            width="100px"
            title="Select"
            cell={(props) => (
              <td>
                <Checkbox
                  checked={props.dataItem.journalTemplateId === selectedTemplateId}
                  onChange={() =>
                    setSelectedTemplateId(props.dataItem.journalTemplateId)
                  }
                />
              </td>
            )}
          />
          <Column field="templateName" title="Title" />
        </Grid>

        {templatesLoading && (
          <div
            className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style={{ background: "rgba(255,255,255,0.6)" }}>
            <Loader size="large" type="infinite-spinner" />
          </div>
        )}
      </div>

      <DialogActionsBar>
        <div className="dialog-footer d-flex gap-2">
          <Button
            className="common-btn bgBtnSecondary"
            type="button"
            onClick={onLoad}
            disabled={!selectedTemplateId || templatesLoading || updatingTemplate}>
            Load
          </Button>
          <Button
            className="common-btn bgBtnSecondary"
            type="button"
            onClick={onEdit}
            disabled={!selectedTemplateId || templatesLoading || updatingTemplate}>
            Edit
          </Button>
          <Button
            className="common-btn bgBtnSecondary"
            type="button"
            onClick={onDelete}
            disabled={!selectedTemplateId || templatesLoading || updatingTemplate}>
            Delete
          </Button>
          <Button
            className="common-btn bgBtnSecondary me-4"
            type="button"
            onClick={onClose}
            disabled={templatesLoading || updatingTemplate}>
            Cancel
          </Button>
        </div>
      </DialogActionsBar>
    </Dialog>
  );
};

export const EditJournalTemplateDialog = ({
  show,
  editingTemplateName,
  setEditingTemplateName,
  updatingTemplate,
  onCancel,
  onSave,
}) => {
  if (!show) return null;

  return (
    <Dialog title="Edit Journal Template" onClose={onCancel} className="dialog-xs">
      <div className="p-4">
        <Label className="mb-1 d-block">Name</Label>
        <Input
          value={editingTemplateName}
          onChange={(e) => setEditingTemplateName(e.target.value)}
          placeholder="Enter template name"
          maxLength={80}
        />
      </div>

      <DialogActionsBar>
        <div className="dialog-footer d-flex gap-2">
          <Button
            className="common-btn bgBtnSecondary"
            type="button"
            onClick={onCancel}
            disabled={updatingTemplate}>
            Cancel
          </Button>
          <SubmitButton
            className="common-btn me-4"
            form="journalTemplateEditForm"
            type="button"
            isLoading={updatingTemplate}
            onClick={onSave}
            disabled={updatingTemplate}>
            Save
          </SubmitButton>
        </div>
      </DialogActionsBar>
    </Dialog>
  );
};
